/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Review_Color_RedInputs */

const en_orders_review_color_red = /** @type {(inputs: Orders_Review_Color_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Red`)
};

const es_orders_review_color_red = /** @type {(inputs: Orders_Review_Color_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rojo`)
};

/**
* | output |
* | --- |
* | "Red" |
*
* @param {Orders_Review_Color_RedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_review_color_red = /** @type {((inputs?: Orders_Review_Color_RedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Review_Color_RedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_review_color_red(inputs)
	return es_orders_review_color_red(inputs)
});